/**
 * Shared markdown renderer: GFM, optional KaTeX, sanitized source (no rehype-raw).
 */
import React from 'react';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import SafeMarkdown from './SafeMarkdown';
import type { Components } from 'react-markdown';

interface MarkdownRendererProps {
  children: string;
  components?: Components;
  enableMath?: boolean;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  children,
  components,
  enableMath = false,
}) => {
  if (enableMath) {
    return (
      <SafeMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={components}
      >
        {children}
      </SafeMarkdown>
    );
  }

  return (
    <SafeMarkdown components={components}>
      {children}
    </SafeMarkdown>
  );
};

export default MarkdownRenderer;
